
import { Component, Vue } from 'vue-property-decorator';
import OsAppSubMenu from '@/components/app/OsAppSubMenu.vue';
import OsSubMenuPage from '@/layouts/pages/OsSubMenuPage.vue';
import { IMenuItem } from '@/models/navigation';
@Component({
  components: { OsSubMenuPage, OsAppSubMenu }
})
export default class AppUsers extends Vue {
  get items(): IMenuItem[] {
    return [
      {
        label: this.$tc('page.appusers.menu.overview.title'),
        subLabel: this.$tc('page.appusers.menu.overview.sub_text'),
        to: `/appusers`,
        exact: true
      }
    ];
  }
}
